<template>
  <UNavigationMenu :items="items" class="w-full justify-center" />
</template>
<script setup lang="ts">
import type { NavigationMenuItem } from '@nuxt/ui'
import type { UserInfo } from '~/types/auth';
const { logout, currentProvider, loggedIn, user, login } = useOidcAuth();

const displayName = computed(() => {
  if (!loggedIn.value || !user.value) return '';

  const userInfo: UserInfo = user.value.userInfo as UserInfo;
  return `${userInfo.name?.first} ${userInfo.name?.last}`.trim();
});

const userRoles = computed(() => {
  if (!loggedIn.value || !user.value) return [];
  
  const userInfo: UserInfo = user.value.userInfo as UserInfo;
  return userInfo.roles || [];
})

const navItems = [{
  label: 'Home',
  icon: 'i-lucide-home',
  to: '/',
}] as NavigationMenuItem[];

if (loggedIn.value) {
  navItems.push({
    label: String(displayName.value),
    icon: 'i-lucide-user-circle',
    class: 'hover:text-primary cursor-pointer',
    to: '/profile'
  });

  if (userRoles.value.includes('admin')) {
    navItems.push({
      label: 'Admin',
      icon: 'i-lucide-shield-check',
      class: 'hover:text-primary cursor-pointer',
      to: '/admin',
    })
  }
  
  navItems.push({
    label: 'Log Out',
    icon: 'i-lucide-log-out',
    class: 'hover:text-primary cursor-pointer',
    onSelect: () => {
      logout(currentProvider.value);
    },
  });
} else {
  navItems.push({
    label: 'Log In',
    icon: 'i-lucide-log-in',
    class: 'hover:text-primary cursor-pointer',
    onSelect: () => {
      login();
    },
  })
}

const items = ref<NavigationMenuItem[]>(navItems);
</script>